export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5241.336598cd.jpg";